var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.remote)?_c('div',{staticClass:"kpt-detail-content-page"},[_c('vue-headful',{attrs:{"title":`${_vm.remote.name} - Activity`}}),_c('div',{staticClass:"kpt-detail-content-actions"},_vm._l((_vm.activities),function(activity,idx){return _c('activity-log-item',{key:idx,attrs:{"model":activity}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }